<div class="gemstone">
	<customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
		@if (!selectableVariants?.length) {
		<div class="no-colors">
			{{'CUSTOMIZER.COMPONENTS.GEMSTONE.NO-COLORS' | translate}}
		</div>
		}
		@else {
		<customizer-colors-auto-update
			[selected]="getSelectedVariant.VariantColor"
			[selectedColorGroup]="currentColorGroup"
			[variants]="selectableVariants || []"
			[editMode]="state === customizerStateEnum.EDITORDER"
			[matchableColors]="matchableColors"
			[useColorGroup]="menu.contentGrouping"
			(colorMatchChange)="matchColors($event)"
			(selectedColorGroupChange)="onSelectGroup($event)"
			(selectedColorChange)="onSelect($event)"
			[(scrollPosition)]="menu.menuDetails.scrollPosition"
			[extendedInformation]="extendedInformation"
			[extendedInformationTable]="false"
			[variantOrModelIsNew]="variantOrModelIsNew"
			[matchColor]="menu.matchColor"
			[showNoneChoiceOption]="false"
		>
		</customizer-colors-auto-update>
		}
	</customizer-component-header>
</div>